import {VueConstructor} from "vue";
import Button from "./Button";
import ButtonIconSimple from "./Button/ButtonIcon/ButtonIconSimple.vue";
import ButtonIconComplexe from "./Button/ButtonIcon/ButtonIconComplexe.vue";
import ButtonIconComplexeSave from "./Button/ButtonIcon/ButtonIconComplexeSave.vue";
import ButtonLabelSimple from "./Button/ButtonLabel/ButtonLabelSimple.vue";
import ButtonLabelComplexe from "./Button/ButtonLabel/ButtonLabelComplexe.vue";

const Buttons: { [key: string]: VueConstructor<any> } = {
    // Bouton Icône
    ButtonIconComplexe: ButtonIconComplexe,
    ButtonIconSave: ButtonIconComplexeSave,
    ButtonIconSimple: ButtonIconSimple,
    ButtonIconEmpty: ButtonIconSimple,
    ButtonIconEdit: ButtonIconSimple,
    ButtonIconDelete: ButtonIconSimple,
    ButtonIconAdd: ButtonIconSimple,
    ButtonIconPublish: ButtonIconSimple,
    ButtonIconArchive: ButtonIconSimple,
    ButtonIconErase: ButtonIconSimple,
    ButtonIconExcel: ButtonIconSimple,
    ButtonIconCancel: ButtonIconSimple,
    ButtonIconClose: ButtonIconSimple,
    ButtonIconLink: ButtonIconSimple,
    ButtonIconMail: ButtonIconSimple,
    ButtonIconSelectAll: ButtonIconSimple,
    ButtonIconSearch: ButtonIconSimple,
    ButtonIconExpand: ButtonIconSimple,
    ButtonIconCollapse: ButtonIconSimple,
    ButtonIconDownload: ButtonIconSimple,
    ButtonIconSign: ButtonIconSimple,
    // Bouton Label
    ButtonLabelComplexe: ButtonLabelComplexe,
    ButtonLabelSimple: ButtonLabelSimple,
    ButtonLabelEmpty: ButtonLabelSimple,
    ButtonLabelEdit: ButtonLabelSimple,
    ButtonLabelSave: ButtonLabelSimple,
    ButtonLabelDelete: ButtonLabelSimple,
    ButtonLabelPublish: ButtonLabelSimple,
    ButtonLabelArchive: ButtonLabelSimple,
    ButtonLabelErase: ButtonLabelSimple,
    ButtonLabelExcel: ButtonLabelSimple,
    ButtonLabelCancel: ButtonLabelSimple,
    ButtonLabelClose: ButtonLabelSimple,
    ButtonLabelSelectAll: ButtonLabelSimple,
    ButtonLabelDownload: ButtonLabelSimple,
    ButtonLabelSign: ButtonLabelSimple,
    Button: Button,
};

enum ButtonTypeEnum {
    Icon = "Icon",
    Label = "Label",
};

enum ButtonActionEnum {
    Complexe = "Complexe",
    Save = "Save",
    Empty = "Empty",
    Edit = "Edit",
    Delete = "Delete",
    Add = "Add",
    Publish = "Publish",
    Archive = "Archive",
    Erase = "Erase",
    SelectAll = "SelectAll",
    Excel = "Excel",
    Cancel = "Cancel",
    Close = "Close",
    Link = "Link",
    Mail = "Mail",
    Search = "Search",
    Expand = "Expand",
    Collapse = "Collapse",
    Download = "Download",
    Sign = "Sign",
    Show = "Show",
    Refresh = "Refresh"
};

export default {Buttons, ButtonTypeEnum, ButtonActionEnum,};
